import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateDynamicSectionForm from '../CreateDynamicSectionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateDynamicSectionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ตั้งค่าการโชว์ Section`}
					description="ตั้งค่าการโชว์ Section"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateDynamicSectionForm />
		</div>
	)
}
